import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initSentry } from "@/utils/logger";

// iter132 — bootstrap Sentry BEFORE React mounts so any error thrown
// during initial render is captured. Stays a no-op when
// REACT_APP_SENTRY_DSN is unset (preview builds & local dev).
initSentry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
